<template>
    <div class="landing">
        <header class="container">
            <nav class="navbar" role="navigation" aria-label="main navigation">
                <div class="navbar-brand">
                    <router-link to="/" class="navbar-item">
                        <img src="../assets/hf_logo.png" alt="Hike & Fly Berguedà" />
                    </router-link>
                    <div class="my-3 has-text-left">
                        <h3 class="title">Hike &amp; Fly</h3>
                        <h3 class="subtitle">Berguedà</h3>
                    </div>
                    <navbar-burger-botton
                        v-bind:class="{ 'is-active': isOpen }"
                        v-on:click="isOpen = !isOpen"
                    ></navbar-burger-botton>
                </div>
                <div class="navbar-menu" v-bind:class="{ 'is-active': isOpen }">
                    <div class="navbar-end">
                        <PreviousEditionsDropdown />
                    </div>
                </div>
            </nav>
        </header>

        <section class="hero is-medium landing-hero">
            <div class="hero-body">
                <div class="container">
                    <p class="landing-kicker">Temporada 2026 – 2027</p>
                    <h1 class="title is-1 has-text-white">
                        El Hike &amp; Fly Berguedà<br />
                        ara vola a <span class="landing-highlight">Flythehike</span>
                    </h1>
                    <p class="subtitle has-text-white mt-4">
                        Els mateixos cims, la mateixa comunitat.<br />
                        Una plataforma nova per pujar, volar i competir.
                    </p>
                    <a
                        v-bind:href="$options.CHALLENGE_URL"
                        class="button is-medium landing-cta mt-4"
                        target="_blank"
                        rel="noopener"
                    >
                        <span>Apunta't al repte</span>
                        <span class="icon"><i class="fas fa-arrow-right"></i></span>
                    </a>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="columns is-variable is-8 is-vcentered">
                    <div class="column is-7 content is-medium">
                        <h2 class="title is-3">Un nou camí per a la competició</h2>
                        <p>
                            Després de quatre edicions comptant cims, zones i combos
                            des d'aquesta web, el Hike &amp; Fly Berguedà s'integra a
                            <a v-bind:href="$options.FLYTHEHIKE_URL" target="_blank" rel="noopener">Flythehike</a>,
                            la plataforma de hike &amp; fly amb rutes de pujada
                            obertes, activitats de la comunitat i classificacions
                            de temporada.
                        </p>
                        <p>
                            La competició continua organitzada pel
                            <strong>Puntxat Parapent Club</strong>. A partir d'ara,
                            la inscripció, la pujada de les activitats i la
                            classificació es fan directament a Flythehike.
                        </p>
                    </div>
                    <div class="column is-5 has-text-centered">
                        <a v-bind:href="$options.FLYTHEHIKE_URL" target="_blank" rel="noopener">
                            <img
                                class="landing-logo"
                                src="../assets/flythehike/flythehike-logo.png"
                                alt="Flythehike"
                            />
                        </a>
                    </div>
                </div>

                <div class="columns is-multiline mt-5">
                    <div class="column is-4">
                        <div class="landing-feature">
                            <span class="icon is-large"><i class="fas fa-calendar-days fa-2x"></i></span>
                            <h3 class="title is-5 mt-3">Una temporada d'un any</h3>
                            <p>
                                La temporada 2026 – 2027 arrenca el 5 d'octubre de 2026 i
                                dura un any sencer, fins al 4 d'octubre de 2027.
                            </p>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="landing-feature">
                            <span class="icon is-large"><i class="fas fa-person-hiking fa-2x"></i></span>
                            <h3 class="title is-5 mt-3">H&amp;F i COMBO</h3>
                            <p>
                                Puja a peu, enlaira't i vola. Encadena diverses
                                parelles hike-fly en una mateixa activitat per fer un
                                COMBO.
                            </p>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="landing-feature">
                            <span class="icon is-large"><i class="fas fa-trophy fa-2x"></i></span>
                            <h3 class="title is-5 mt-3">Classificació en directe</h3>
                            <p>
                                Puja el teu track GPS a Flythehike i la puntuació de
                                la fase hike i de la fase fly es calcula automàticament.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section landing-invite">
            <div class="container has-text-centered">
                <img
                    class="landing-icon"
                    src="../assets/flythehike/flythehike-icon.png"
                    alt=""
                />
                <h2 class="title is-3 mt-4">Et convidem a descobrir la plataforma</h2>
                <p class="subtitle is-5 mt-3">
                    Crea el teu compte, explora les rutes i apunta't al repte.
                    Ens veiem als enlairaments!
                </p>
                <div class="buttons is-centered mt-5">
                    <a
                        v-bind:href="$options.CHALLENGE_URL"
                        class="button is-medium is-dark"
                        target="_blank"
                        rel="noopener"
                        >Veure el repte Hike &amp; Fly Berguedà</a
                    >
                    <a
                        v-bind:href="$options.FLYTHEHIKE_URL"
                        class="button is-medium is-dark is-outlined"
                        target="_blank"
                        rel="noopener"
                        >Conèixer Flythehike</a
                    >
                </div>
                <p class="mt-5">
                    Vols consultar els resultats d'anys anteriors? Els tens a
                    <strong>Edicions anteriors</strong>, al menú de dalt.
                </p>
            </div>
        </section>

        <footer class="landing-footer has-text-centered">
            <img src="../assets/puntxat.png" class="landing-footer-logo" title="Puntxat Parapent Club" />
        </footer>
    </div>
</template>

<script>
import NavbarBurgerBotton from "../components/NavbarBurgerBotton.vue";
import PreviousEditionsDropdown from "../components/PreviousEditionsDropdown.vue";

export default {
    name: "Edition2026",
    FLYTHEHIKE_URL: "https://flythehike.com/ca",
    CHALLENGE_URL: "https://flythehike.com/ca/reptes/hike-fly-bergueda",
    components: {
        NavbarBurgerBotton,
        PreviousEditionsDropdown,
    },
    data() {
        return {
            isOpen: false,
        };
    },
    mounted() {
        this.$root.$emit("ready");
    },
};
</script>

<style lang="scss" scoped>
// Only this page uses hero/content, keep them out of the global stylesheet
@import "../styles/variables";
@import "bulma/sass/utilities/_all.sass";
@import "bulma/sass/layout/hero.sass";
@import "bulma/sass/elements/content.sass";

$fth-lime: #c0ff00;
$fth-ink: #111111;

.landing-hero {
    background: linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.65)),
        url("../assets/flythehike/bergueda-cover.jpg") center / cover no-repeat;
}

.landing-kicker {
    color: $fth-lime;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 0.75rem;
}

.landing-highlight {
    color: $fth-lime;
}

.landing-cta {
    background-color: $fth-lime;
    border-color: $fth-lime;
    color: $fth-ink;
    font-weight: 700;

    &:hover {
        background-color: darken($fth-lime, 6%);
        color: $fth-ink;
    }
}

.landing-logo {
    max-width: 100%;
    border-radius: 12px;
}

.landing-feature {
    height: 100%;
    padding: 1.5rem;
    border-radius: 12px;
    background: #fafafa;

    .icon {
        color: $fth-ink;
    }
}

.landing-invite {
    background-color: $fth-lime;
    color: $fth-ink;

    .title,
    .subtitle {
        color: $fth-ink;
    }
}

.landing-icon {
    width: 72px;
    height: 72px;
    border-radius: 16px;
}

.landing-footer {
    padding: 2rem 1.5rem 3rem;
}

.landing-footer-logo {
    height: 60px;
}

@include mobile {
    .landing-hero .title.is-1 {
        font-size: 2.25rem;
    }
}
</style>
